(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
        this.updatePinnedHeader();
      });
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.headerSpacer = document.createElement('div');
        this.headerSpacer.className = 'cos-header-spacer';
        this.headerSpacer.dataset.desktopOverlay = this.dataset.desktopOverlay;
        this.headerSpacer.dataset.mobileOverlay = this.dataset.mobileOverlay;
        this.headerSpacer.setAttribute('aria-hidden', 'true');
        this.header.before(this.headerSpacer);
        this.announcementSection = document.querySelector('.cos-announcement-section');
        this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
        this.layoutObserver = new ResizeObserver(() => this.updatePinnedHeader());
        if (this.announcementSection) this.layoutObserver.observe(this.announcementSection);
        if (this.heroBanner) this.layoutObserver.observe(this.heroBanner);
        this.onLayoutChange = () => {
          this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
          if (this.heroBanner) this.layoutObserver.observe(this.heroBanner);
          this.updatePinnedHeader();
        };
        window.addEventListener('resize', this.onLayoutChange);
        window.addEventListener('load', this.onLayoutChange);
        document.addEventListener('shopify:section:load', this.onLayoutChange);
        this.updatePinnedHeader();
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.headerSpacer?.style.setProperty('--cos-spacer-height', `${this.header.offsetHeight}px`);
    }

    updatePinnedHeader() {
      if (!this.headerSpacer) return;
      const announcementHeight = this.announcementSection?.getBoundingClientRect().height || 0;
      this.header.style.setProperty('--cos-announcement-height', `${announcementHeight}px`);
      this.header.classList.add('cos-header-pinned');
      this.headerSpacer.classList.add('cos-header-spacer--active');
      this.headerSpacer.style.setProperty('--cos-spacer-height', `${this.header.offsetHeight}px`);
      this.heroBanner = document.querySelector(this.dataset.heroSelector || 'cos-home-banner');
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const overlayEnabled = desktop ? this.dataset.desktopOverlay === 'true' : this.dataset.mobileOverlay === 'true';
      const overHero = overlayEnabled
        && this.heroBanner
        && this.heroBanner.getBoundingClientRect().bottom > announcementHeight + this.header.offsetHeight;
      this.header.classList.toggle('cos-header-over-hero', Boolean(overHero));
    }

    disconnectedCallback() {
      this.headerSpacer?.remove();
      this.header.classList.remove('cos-header-pinned', 'cos-header-over-hero');
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.onLayoutChange);
      window.removeEventListener('load', this.onLayoutChange);
      document.removeEventListener('shopify:section:load', this.onLayoutChange);
      this.headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerIsAlwaysSticky) {
        this.updatePinnedHeader();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-video-slider"] && !Shopify.designMode) return;
  try {
    
  // Shopify bundles this once. Custom elements reconnect after section HTML
  // replacement, which does not execute inline scripts or emit section:load.
  if (!customElements.get('jk-video-slider')) {
    customElements.define('jk-video-slider', class extends HTMLElement {
      connectedCallback() {
        this.onMute = this.handleMute.bind(this);
        this.onDragStart = function (event) { event.preventDefault(); };
        this.onWindowLoad = this.initSlider.bind(this);
        queueMicrotask(() => {
          if (!this.isConnected) return;
          if (typeof window.Swiper === 'function') {
            this.initSlider();
          } else {
            window.addEventListener('load', this.onWindowLoad, { once: true });
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.onWindowLoad);
        this.destroySlider();
      }

      handleMute(event) {
        const button = event.target.closest('.video-mute-btn');
        if (!button || (this.slider && !this.slider.allowClick)) return;
        const video = button.closest('.video-wrapper').querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.querySelector('.icon-muted').style.display = video.muted ? 'block' : 'none';
        button.querySelector('.icon-unmuted').style.display = video.muted ? 'none' : 'block';
        button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      syncVideoPlayback(swiper) {
        if (!swiper || swiper.destroyed) return;
        const bounds = swiper.el.getBoundingClientRect();
        swiper.el.querySelectorAll('video').forEach(function (video) {
          const rect = video.getBoundingClientRect();
          if (rect.right > bounds.left + 1 && rect.left < bounds.right - 1) {
            const playRequest = video.play();
            if (playRequest) playRequest.catch(function () {
              // The poster remains visible if the browser blocks autoplay.
            });
          } else {
            video.pause();
          }
        });
      }
      destroySlider() {
        this.removeEventListener('click', this.onMute);
        this.removeEventListener('dragstart', this.onDragStart);
        if (this.slider && !this.slider.destroyed) this.slider.destroy(true, true);
        this.slider = null;
        this.querySelectorAll('video').forEach(function (video) { video.pause(); });
      }

      initSlider() {
        if (!this.isConnected || typeof window.Swiper !== 'function') return;
        this.destroySlider();
        const sliderElement = this.querySelector('.product_video_slider');
        const wrapper = sliderElement && sliderElement.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        if (sliderElement.swiper) sliderElement.swiper.destroy(true, true);
        wrapper.querySelectorAll('[data-loop-clone="true"]').forEach(function (slide) {
          slide.remove();
        });
        const originalSlides = Array.from(wrapper.children);
        if (!originalSlides.length) return;

        // Keep two desktop views available, repeating complete video sequences.
        const copiesNeeded = Math.max(0, Math.ceil(10 / originalSlides.length) - 1);
        for (let copy = 0; copy < copiesNeeded; copy++) {
          originalSlides.forEach(function (slide) {
            const clone = slide.cloneNode(true);
            clone.setAttribute('data-loop-clone', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach(function (element) {
              element.removeAttribute('id');
            });
            wrapper.appendChild(clone);
          });
        }
        wrapper.querySelectorAll('video').forEach(function (video) {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('loading', 'eager');
        });
        const syncPlayback = this.syncVideoPlayback;
        this.slider = new window.Swiper(sliderElement, {
          loop: true,
          loopPreventsSliding: false,
          rewind: false,
          slidesPerView: 1.5,
          slidesPerGroup: 1,
          spaceBetween: 12,
          speed: 650,
          grabCursor: true,
          simulateTouch: true,
          allowTouchMove: true,
          threshold: 2,
          followFinger: true,
          freeMode: {
            // Mouse dragging stays between cards and coasts on release.
            // Touch devices retain their existing swipe-and-snap behavior.
            enabled: window.matchMedia('(pointer: fine)').matches,
            momentum: true,
            momentumRatio: 0.65,
            momentumVelocityRatio: 0.8,
            momentumBounce: false,
            sticky: false
          },
          noSwipingSelector: '.video-mute-btn',
          watchOverflow: false,
          observer: true,
          observeParents: true,
          on: {
            init: syncPlayback,
            slideChangeTransitionEnd: syncPlayback,
            resize: function (swiper) {
              requestAnimationFrame(function () { syncPlayback(swiper); });
            }
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          mousewheel: { forceToAxis: true, sensitivity: 1 },
          breakpoints: {
            750: { slidesPerView: 3, spaceBetween: 16 },
            1000: { slidesPerView: 4, spaceBetween: 20 },
            1300: { slidesPerView: 5, spaceBetween: 20 }
          }
        });
        this.addEventListener('click', this.onMute);
        this.addEventListener('dragstart', this.onDragStart);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
